import httpClient from './httpClient'
import wrapperDataProvider from './wrapperDataProvider'

export { httpClient }

export default wrapperDataProvider
